// extracted by mini-css-extract-plugin
export default {"characteristic":"MQ79H","characteristicValue":"vdukP","sizeValue":"pwHtE","list":"Nmv4q","parameter":"aoJQe","themeHardness":"xQueY","icon":"bcy8Q"};